<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Agenda do prestador</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Unidade prestadora</label>
                                    <select-unidade
                                        @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadeSelecionada(unidadeSelecionada);
                                            }
                                        "
                                    ></select-unidade>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Profissional</label>
                                    <select-profissional
                                        @setProfissionalSelecionado="
                                            profissionalSelecionado => {
                                                setProfissionalSelecionado(profissionalSelecionado);
                                            }
                                        "
                                    ></select-profissional>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="">Procedimento</label>
                                    <select-procedimento
                                        @setProcedimentoSelecionado="
                                            procedimentoSelecionado => {
                                                setProcedimentoSelecionado(procedimentoSelecionado);
                                            }
                                        "
                                    ></select-procedimento>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="">Sub-Grupo</label>
                                    <select-subgrupo
                                        @setSubgrupoSelecionado="
                                            subgrupoSelecionado => {
                                                setSubgrupoSelecionado(subgrupoSelecionado);
                                            }
                                        "
                                    ></select-subgrupo>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="data_de">Período</label>
                                    <data-filtro name="periodo" @operadorSelecionado="filtros.periodoOperador = $event" @dataSelecionada="filtros.periodo = $event" @data2Selecionada="filtros.periodo2 = $event"></data-filtro>
                                </div>
                            </div>
                        </div>
                        <div class="box-footer text-right" ref="filtrar">
                            <button class="btn btn-info" :disabled="finalizado" @click.self.prevent="getPDF(filtros.modelo)" v-if="pdf">Recarregar PDF <span class="fa fa-file-pdf-o" aria-hidden="true"></span></button>
                            <button @click="getDataTable()" data-toggle="tooltip" title="Pesquisar Agenda do Prestador" class="btn btn-primary" :disabled="finalizado"><span class="fa fa-search"></span> Pesquisar</button>
                        </div>
                        <div v-if="pdf">
                            <embed type="application/pdf" :src="pdf" width="100%" :height="heigthPdf" />
                        </div>
                        <div class="row" v-if="!isEmpty(dataTable) && !pdf">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Falta</th>
                                                <!-- <th>Solicitação</th> -->
                                                <th v-show="ativos.situacao">Situação</th>
                                                <th v-show="ativos.profissional">Profissional</th>
                                                <th v-show="ativos.paciente">Paciente</th>
                                                <th v-show="ativos.telefone">Telefone</th>
                                                <th v-show="ativos.procedimento">Procedimento</th>
                                                <th v-show="ativos.rg">RG</th>
												<th v-show="ativos.cartao_sus">Cartão SUS</th>
                                                <th v-show="ativos.data_nascimento">Data de Nascimento</th>
                                                <th v-show="ativos.idade">Idade</th>
                                                <th v-show="ativos.sexo">Sexo</th>
                                                <th v-show="ativos.data_realizacao">Data do atendimento</th>
                                                <th v-show="ativos.tipo">Tipo</th>
                                                <th v-show="ativos.endereco">Endereço</th>
                                                <th v-show="ativos.municipio">Município</th>
                                                <th v-show="ativos.unidade_solicitante">Unidade solicitante</th>
                                                <th v-show="ativos.subgrupo">Subgrupo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in dataTable.data" :key="index">
                                                <td>
                                                    <button @click="lancarFalta(item)" data-toggle="tooltip" title="Lançar falta" :disabled="disabledBtnFalta(item)" class="btn btn-danger btn-sm"><span class="fa fa-times"></span></button>
                                                </td>
                                                <td v-show="ativos.situacao">{{ item.solicitacao.situacao | situacaoSolicitacao }}</td>
                                                <td v-show="ativos.profissional">{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL" }}</td>
                                                <td v-show="ativos.paciente">{{ item.solicitacao.paciente.nome }}</td>
                                                <td v-show="ativos.telefone">{{ item.solicitacao.paciente.telefone }}</td>
                                                <td v-show="ativos.procedimento">{{ item.contrato_procedimento.procedimento.nome }}</td>
                                                <td v-show="ativos.rg">{{ item.solicitacao.paciente.rg }}</td>
												<td v-show="ativos.cartao_sus">{{ item.solicitacao.paciente.cartao_sus }}</td>
                                                <td v-show="ativos.data_nascimento">{{ item.solicitacao.paciente.data_nascimento | dataFormatada }}</td>
                                                <td v-show="ativos.idade">{{ item.solicitacao.paciente.data_nascimento | idade }}</td>
                                                <td v-show="ativos.sexo">{{ item.solicitacao.paciente.sexo | sexo }}</td>
                                                <td v-show="ativos.data_realizacao">{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento | dataFormatada }} às {{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial }}</td>
                                                <td v-show="ativos.tipo">{{ item.tipo_consulta | tipoConsulta }}</td>
                                                <td v-show="ativos.endereco">{{ item.solicitacao.paciente.endereco }}, nº{{ item.solicitacao.paciente.numero_endereco }}, {{ item.solicitacao.paciente.bairro }}</td>
                                                <td v-show="ativos.municipio">{{ item.solicitacao.paciente.cidade.nome }}</td>
                                                <td v-show="ativos.unidade_solicitante">{{ item.contrato_procedimento.contrato.unidade.nome }}</td>
                                                <td v-show="ativos.subgrupo">{{ item.contrato_procedimento.procedimento.forma_organizacao.subgrupo.nome }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="dataTable.data && dataTable.data.length > 0">
                            <div class="col-sm-4 text-left">
                                <button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF(1)"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> Modelo 1</button>
                                <button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF(2)"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> Modelo 2</button>
                                <button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF(3)"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> Modelo 3</button>
                            </div>
                            <div class="col-sm-4 text-center">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                            <div class="col-sm-4" style="text-align:right">
                                <laravue-pagination :limit="7" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                        <br />
                        <div v-if="!isEmpty(dataTable)" class="row">
                            <div class="col-sm-3">
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.situacao" />Situação </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.tipo" />Tipo </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.data_realizacao" />Data atendimento </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.paciente" />Paciente </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.rg" />RG </label>
                                </div>
								<div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.cartao_sus" />Cartão SUS </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.profissional" />Profissional </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.subgrupo" />Subgrupo </label>
                                </div>

                            </div>
                            <div class="col-sm-3">
								<div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.data_nascimento" />Data de nascimento </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.idade" />Idade </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.procedimento" />Procedimento </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.unidade_solicitante" />Unidade Solicitante </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.telefone" />Telefone </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.sexo" />Sexo </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.endereco" />Endereço </label>
                                </div>
                                <div class="checkbox">
                                    <label> <input type="checkbox" v-model="ativos.municipio" />Município </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import selectProfissional from "@/components/cadastros/profissionais/selectProfissional";
import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
import selectSubgrupo from "@/components/cadastros/procedimentos/subgrupos/selectSubgrupo";
import DataFiltro from "@/components/componentes/DataFiltro";
import { SITUACAO_SOLICITACAO } from "@/constants";
export default {
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({
        pdf: null,
        heigthPdf: 900,
        finalizado: false,
        filtros: {
            unidade_id: "",
            unidade: "",
            profissional_id: "",
            profissional: "",
            procedimento_id: "",
            procedimento: "",
            subgrupo_id: "",
            subgrupo: "",
            periodo: "",
            periodo2: "",
            periodoOperador: "",
            modelo: "",
            ativos: null
        },
        dataTable: {},
        ativos: {
            situacao: true,
            data_realizacao: true,
            paciente: true,
            rg: true,
			cartao_sus: true,
            data_nascimento: true,
            idade: true,
            procedimento: true,
            unidade_solicitante: true,
            profissional: true,
            telefone: true,
            sexo: true,
            tipo: true,
            endereco: true,
            municipio: true,
            subgrupo: true
        }
    }),
    mounted() {},
    methods: {
        disabledBtnFalta(item) {
            let dataAtendimento = item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento;
            if (item.solicitacao.situacao == SITUACAO_SOLICITACAO.MARCADA || item.solicitacao.situacao == SITUACAO_SOLICITACAO.CONFIRMADA) {
                return new Date() < new Date(dataAtendimento);
            }
            return true;
        },
        lancarFalta(item) {
            let dados = {
                solicitacaoId: item.solicitacao.id,
                situacao: SITUACAO_SOLICITACAO.FALTA
            };
            this.$swal({
                title: "Confirmar falta?",
                text: "Está ação não poderá ser desfeita.",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/atualizarSituacao`, dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.solicitacao = response.data;
                            this.$swal({
                                type: "success",
                                title: "Solicitação atualizada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.getDataTable();
                            this.$store.commit("TOGGLE_LOADING");
                        })
                        .catch(error => {
                            this.$store.commit("throwException", error);
                        });
                }
            });
        },
        getDataTable(page) {
			let loader = this.$loading.show()
            if (!this.filtros.unidade_id || !this.filtros.periodo) {
                this.$swal({
                    type: "warning",
                    title: "Atenção!",
                    text: "É necessário selecionar a unidade prestadora e o período!",
                    showConfirmButton: true
                });
                return;
            }
            this.finalizado = true;
            this.pdf = null;
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;

            this.$store.commit("TOGGLE_LOADING");
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/relatorios/agendaPrestador`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                    this.finalizado = false;
					loader.hide()
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                    this.finalizado = false;
					loader.hide()
                });
        },
        setUnidadeSelecionada(unidadeSelecionada) {
            this.filtros.unidade_id = unidadeSelecionada.id;
            this.filtros.unidade = unidadeSelecionada.nome;
        },
        setProfissionalSelecionado(profissionalSelecionado) {
            this.filtros.profissional_id = profissionalSelecionado.id;
            this.filtros.profissional = profissionalSelecionado.nome;
        },
        setSubgrupoSelecionado(subgrupoSelecionado) {
            this.filtros.subgrupo_id = subgrupoSelecionado.id;
            this.filtros.subgrupo = subgrupoSelecionado.nome;
        },
        setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
            this.filtros.procedimento = procedimentoSelecionado.nome;
        },
        isEmpty(objeto) {
            return Object.values(objeto).every(valor => valor === "");
        },
        getPDF(modelo) {
            this.finalizado = true;
            this.filtros.modelo = modelo;
            if (modelo == 1) {
                this.filtros.ativos = this.ativos;
            }
            this.$store.commit("TOGGLE_LOADING");
            axios
                .post(`${this.$store.state.serverURI}/api/relatorios/agendaPrestadorImprimir`, this.filtros, this.$store.getters.getHeaderAuthFile)
                .then(response => {
                    this.$store.commit("TOGGLE_LOADING");
                    const file = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    const fileURL = window.URL.createObjectURL(file);
                    this.pdf = fileURL;
                    let self = this;
                    this.heigthPdf = window.innerHeight - 65;
                    console.log(window.innerHeight);
                    setTimeout(function() {
                        self.$refs.filtrar.scrollIntoView();
                    }, 300);
                    this.finalizado = false;
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                    this.finalizado = false;
                });
        }
    },
    watch: {},
    components: {
        selectUnidade,
        selectProfissional,
        selectProcedimento,
        selectSubgrupo,
        DataFiltro
    }
};
</script>

<style>
.pdf {
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// index.vue?60a6c4fe